import React from 'react';
import { HStack } from 'native-base';
import AppText from '../../../../../../common/AppText';
import UserAvatar from '../../../../../../common/UserAvatar';
import AdvanceSelect from '../../../../../../common/AdvanceSelect';
import FormInput from '../../../../../../common/FormInput';
import { t } from '../../../../../../../services/i18n';
import { GlobalStyleAttributes } from '../../../../../../../styles/GlobalStyles';
import { COACH_SELECT } from '../../../../../../../services/ConstHelper';
import {Colors} from "../../../../../../../styles/Colors";
import {useSelector} from "react-redux";
import {getSortedCoachesForSyncInvite} from "../../../../../../../services/Helpers";

const SendSyncInviteSelect = (props) => {
    const { values, setFieldValue, touched, errors } = props;
    const user = useSelector(state => state.user.user)
    const options = getSortedCoachesForSyncInvite()

    return (
        <FormInput
            containerProps={{mb: '2rem'}}
            infoTooltip={t('send-sync-invite-tooltip')}
            label={t('send-sync-invite-input')}
            width={'100%'}
            error={(touched.users_boxes && errors.users_boxes) ? errors.users_boxes : null}
        >
            <AdvanceSelect
                placeholder={t('select-coach')}
                isMulti
                type={COACH_SELECT}
                dontSort={true}
                target={{name: 'users_boxes', value: 'id'}}
                options={options.map(opt => ({
                    ...opt,
                    label: opt.shortLabel || opt.label,
                    fullLabel: opt.label
                }))}
                formatOptionLabel={(option, { context }) => {
                    // For dropdown menu, show full label with avatar
                    if (context === 'menu') {
                        return (
                            <HStack alignItems={'center'} space={'0.5rem'} overflowX={'hidden'}>
                                <UserAvatar imageUri={option.cloudinary_image} size={25} firstName={option.first_name} lastName={option.last_name}/>
                                <HStack space={'0.5rem'}>
                                    <AppText fontSize={GlobalStyleAttributes.fonts.standard16}>{option.fullLabel}</AppText>
                                    <AppText fontSize={GlobalStyleAttributes.fonts.standard16} color={Colors.newDesign.darkGrey}>{option.user_fk === user.user_fk ? `(${t('assign-to-me')})` : ''}</AppText>
                                </HStack>
                            </HStack>
                        );
                    }
                    // For selected values, show shortLabel
                    return <AppText fontSize={GlobalStyleAttributes.fonts.standard16}>
                        {option.label}
                        </AppText>
                }}
                initValue={values.users_boxes}
                onChange={(value) => {
                    const hasAll = value?.some(item => item.value === 'all');
                    const prevHasAll = values.users_boxes?.some(item => item.value === 'all');

                    // If "all" was just selected, keep only "all"
                    if (hasAll && !prevHasAll) {
                        const allOption = value.find(item => item.value === 'all');
                        setFieldValue('users_boxes', [allOption]);
                    }
                    // If "all" was already selected and user selects something else, remove "all"
                    else if (prevHasAll && value?.length > 1) {
                        setFieldValue('users_boxes', value.filter(item => item.value !== 'all'));
                    }
                    // Otherwise, set the value normally
                    else {
                        setFieldValue('users_boxes', value);
                    }
                }}
                isError={touched.users_boxes && errors.users_boxes}
            />
        </FormInput>
    );
};

export default SendSyncInviteSelect;
